import { graphql, Link, StaticQuery } from "gatsby"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import Links from "../common/links"
import SVGIcon from "../common/SVGIcon"

const EventFooter = () => {
  var d = new Date()
  var currentYear = d.getFullYear()

  return (
    <StaticQuery
      query={graphql`
        query contentEventFooter {
          SuperOps {
            pages(where: { title: "Footer Block" }) {
              pageBlock {
                id
                content {
                  html
                }
              }
            }
            links(where: { where: "Footer" }) {
              section
              linkName
              slug
              icon {
                url
              }
            }
          }
        }
      `}
      render={data => (
        <div>
          {data.SuperOps.pages.map(page => {
            const { pageBlock } = page
            return (
              <>
                <div className="event-footer">
                  <Container>
                    <Row>
                      <Col lg={5} sm={12}>
                        <Link to="/">
                          <SVGIcon name="logo-icon" width="25" />
                        </Link>
                        <p className="logo-text fw-bold">
                          Powered by AI <br /> Superpowered for MSPs
                        </p>
                      </Col>

                      <Col lg={2} sm={6}>
                        <div className="footer-links-header">Company</div>
                        <div className="footer-links">
                          <a href="/about-us">About superops</a>
                        </div>
                      </Col>

                      <Col lg={3} sm={6}>
                        <div className="footer-links-header">Contact us</div>
                        <div className="footer-links">
                          <a href="mailto:contact@superops.com">
                            contact@superops.com
                          </a>
                        </div>
                      </Col>

                      <Col lg={2} sm={12}>
                        <div className="footer-links-header">Follow us on</div>
                        <div className="footer-links d-flex">
                          <Links items={data.SuperOps.links[7]} iconOnly />{" "}
                        </div>
                      </Col>
                    </Row>

                    <Row className="otr-links mt40">
                      <Col lg={5} sm={12}>
                        <div classname="p12">
                          {" "}
                          <p>
                            {" "}
                            © {currentYear} SuperOps. All rights reserved{" "}
                          </p>
                        </div>
                      </Col>

                      <Col lg={6} sm={12}>
                        <Links items={data.SuperOps.links[6]} />
                      </Col>
                    </Row>
                  </Container>
                </div>
              </>
            )
          })}
        </div>
      )}
    ></StaticQuery>
  )
}

export default EventFooter
